import React, { memo, useCallback } from 'react';

import { CheckboxCDS } from '@sharedCR/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { checkboxStyles } from './CheckboxCellContent.styles';

const CheckboxCellContent = ({ isChecked = false, isDisabled = false, onClick, itemId }) => {
  const handleClick = useCallback(
    e => {
      e.stopPropagation();

      onClick?.(itemId);
    },
    [onClick, itemId],
  );

  return (
    <CheckboxCDS
      customStyles={checkboxStyles}
      disabled={isDisabled}
      value={isChecked}
      onClick={handleClick}
    />
  );
};

CheckboxCellContent.propTypes = {
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
};

export default memo(CheckboxCellContent);
